module.exports = __webpack_public_path__ + "static/img/app02.243711cf.png";